import styled from 'styled-components';
import Heading from "../../../type/Heading.js";
export var StyledHeader = styled.div.withConfig({
  componentId: "CL__sc-273za2-0"
})(["align-items:start;display:flex;gap:var(--spacing-1);"]);
export var StyledHeading = styled(Heading).attrs({
  size: 'xx-small'
}).withConfig({
  componentId: "CL__sc-273za2-1"
})(["flex-grow:1;font:inherit;font-weight:var(--heading-font-weight);"]);